module.exports = __webpack_public_path__ + "images/emoji/moneybag.cb1f5750a09a54991d89.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/moneybag.png
// module id = Bhlg
// module chunks = 13